import { gql } from '@apollo/client'
import { DRAW_MAP_TASK_FRAGMENT } from '../fragments/DrawMapTaskFragment'

export const CREATE_INDOOR_MAP_DRAW_TASK = gql`
  mutation CreateIndoorMapDrawTask($input: CreateIndoorMapDrawTaskInput!) {
    createIndoorMapDrawTask(input: $input) {
      indoorMapDrawTask {
        ...DrawMapTask
      }
    }
  }
  ${DRAW_MAP_TASK_FRAGMENT}
`
